import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteSdkClientMutation, deleteSdkClientMutationVariables } from '../generated/deleteSdkClientMutation';
import { sdkClientFieldsFragment } from '../models/SdkClient';

/**
 * Get a callback to delete a SdkClient in the store.
 */
export function useDeleteSdkClientCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteSdkClientMutation, deleteSdkClientMutationVariables>(
        gql`
            mutation deleteSdkClientMutation ($id: ID!) {
                deleteSdkClient(id: $id) {
                    ...sdkClientFields
                }
            }

            ${sdkClientFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
